// extracted by mini-css-extract-plugin
module.exports = {"revalidate":"revalidate__1O9Yr","title":"title__3Vvr7","password":"password__3FdL3","nextButton":"nextButton__3Vp3k","error":"error__J6KHJ"};